var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "news-article area"
  }, [_c("news-panel", _vm._b({
    attrs: {
      articleList: _vm.articleList,
      total: _vm.total
    },
    on: {
      pageChange: _vm.handlePageChange,
      sizeChange: _vm.handleSizeChange
    }
  }, "news-panel", _vm.$attrs, false))], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };